<cm-page-header text="Test Registration Form" [backUrl]="backUrl"></cm-page-header>
<cm-registration-form-preview
    class="form-container"
    [registrationFormFields]="registrationFormFields"
></cm-registration-form-preview>
<div class="card-footer">
    <button class="btn btn-primary" *ngIf="(isRegistrationFormEditable$ | async)" (click)="editRegistrationForm()">
        Edit
    </button>
</div>
